
/**
 * Autocomplete
 */
const AutoComplete = function(element, options) {
    this.element = $(element);

    this.options = $.extend({
        minLength: 1,
        display: $.proxy(this.display, this),
        prepare: $.proxy(this.prepare, this),
        highlight: true,
        url: null,
        field: 'label',
        template: '{{label}}'
    }, options);

    this.url   = this.options.url;
    this.label = this.options.label;

    this.dataSource = new Bloodhound({
        datumTokenizer: $.proxy(this.tokenizer, this),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: this.url,
            prepare: this.options.prepare,
            transform: function(response) {
                return response
            },
            cache: false
        }
    });

    this.element.typeahead({
        hint: true,
        highlight: this.options.highlight,
        minLength: this.options.minLength
    }, {
        source: this.dataSource,
        display: this.options.display,
        templates: {
            suggestion: Handlebars.compile('<div>' + this.options.template + '</div>')
        },
        limit: 50
    });

    // this.element.on('typeahead:select', $.proxy(this.dispatch, this));

    this.element.on('typeahead:asyncrequest', $.proxy(this.onAsyncRequest, this));
    this.element.on('typeahead:asynccancel', $.proxy(this.onAsyncFinish, this));
    this.element.on('typeahead:asyncreceive', $.proxy(this.onAsyncFinish, this));
};

$.extend(AutoComplete.prototype, {
    onAsyncRequest: function(event) {
        this.element.closest('.twitter-typeahead').addClass('loading');
    },

    onAsyncFinish: function(event) {
        this.element.closest('.twitter-typeahead').removeClass('loading');
    },

    tokenizer: function(data) {
        return Bloodhound.tokenizers.whitespace(data.value);
    },

    display: function(data) {
        return data[this.options.value];
    },

    prepare: function(query, settings) {
        const data = {
            search: query
        };
        // Trigger custom event with data as the second argument
        const event = jQuery.Event('autocomplete:request');
        this.element.trigger(event, [ data ]);

        settings.data = data;
        return settings;
    },

    clear: function() {
        var typeahead = this.element.data('tt-typeahead');

        typeahead.menu.empty();
    }
});

$.fn.autocomplete = function(options) {
    var args = Array.prototype.slice.call(arguments, 1);

    return $.each(this, function(index, element) {
        element = $(element);

        var autoComplete = element.data('leaderbox.autoComplete');

        if (typeof options == 'string') {
            if (!autoComplete) {
                return;
            }

            autoComplete[options].apply(autoComplete, args);
        }

        if (!autoComplete) {
            autoComplete = new AutoComplete(element, options);
            element.data('leaderbox.autoComplete', autoComplete);
        }
    })
};



const autocompleteVilles = () => {
    const villeSelector = '[data-autocomplete-ville]:not([class~="tt-hint"])',
          codePostalSelector = '[data-autocomplete-code-postal]:not([class~="tt-hint"])';

    $(document).arrive(villeSelector, {
        existing: true
    }, function() {
        $(this).autocomplete({
            url: Routing.generate('ville_autocomplete'),
            value: 'ville',
            template: '{{ville}} ({{codePostal}})'
        }).on('autocomplete:request', (event, data) => {
            data.sort = 'ville';
        }).on('typeahead:select', function(event, data) {
            $(event.currentTarget).closest('form').find(codePostalSelector).val(data.codePostal);
        });
    });

    $(document).arrive(codePostalSelector, {
        existing: true
    }, function() {
        $(this).autocomplete({
            url: Routing.generate('ville_autocomplete'),
            value: 'codePostal',
            template: '{{codePostal}} ({{ville}})'
        }).on('autocomplete:request', (event, data) => {
            data.sort = 'codePostal';
        }).on('typeahead:select', function(event, data) {
            $(event.currentTarget).closest('form').find(villeSelector).val(data.ville);
        });
    });
};


const uppercaseInput = () => {
    const selector = '[data-uppercase]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        $(this).on('keyup', event => {
            const target = $(event.target);

            target.val(target.val().toUpperCase());
        })
    });
};

const capitalizeInput = () => {
    const selector = '[data-capitalize]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        $(this).on('keyup', event => {
            const target = $(event.target),
                  val = target.val();

            target.val(val.charAt(0).toUpperCase() + val.slice(1));
        })
    });
};

export {
    autocompleteVilles,
    uppercaseInput,
    capitalizeInput
}


// WEBPACK FOOTER //
// ./js/form/autocomplete.js